import axios from "axios";
import { useState } from "react";
import "./registration.css";
import { BASE_URL } from "./axios";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { PasswordEye, PasswordEyeHidden } from "../../utils/ReusableSVGs";


const Login = () => {
  const navigate = useNavigate();
  const [errMsg, setErrMsg] = useState("");

  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });


  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [showPassword, setShowPassword] = useState(false);


  const validateForm = () => {
    const newErrors = {};
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    }
    else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }

    const requiredFields = [
      'password',
    ];

    requiredFields.forEach(field => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };





  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {

      const logingToastId = toast.loading(`Logging In...`); //toast Logic

      try {
        let res = await axios.post(`${BASE_URL}/user/login/`, formData);
        console.log(res)
        if (res.status === 200) {
          const { access, refresh, payload } = res.data;
          const sessionData = {
            access_token: access,
            refresh_token: refresh,
            role: payload.role,
            email: payload.email,
          };
          Object.entries(sessionData).forEach(([key, value]) => sessionStorage.setItem(key, value));
          window.location.reload();
          // navigate("/ed");
        }
        else {
          setErrMsg("Invalid Email Or Password")
        }
      }
      catch (err) {
        console.log(err);
        setErrMsg(err.response.data.error);
        // setErrMsg("Invalid Email Or Password");

        //toast Logic
        if (err.response) {
          toast.dismiss(logingToastId);
          const errorData = err.response.data;
          if (typeof errorData.error === 'string') { // Single error message   
            toast.error(`Error: ${errorData.error}`);
          } else if (typeof errorData === 'object' && errorData !== null) {// Multiple error messages
            Object.entries(errorData).forEach(([field, messages]) => {
              messages.forEach(message => toast.error(`"${field}": ${message}`));
            });
          } else {
            toast.error('Error:- Failed to Process!');
          }
        } else {
          toast.error('Error processing your request.');
        }

      } finally {

        // toast.dismiss(loadingToastId);
      }
    }
    else {
      console.log('Form contains errors:', errors);
    }
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? 'green' : '',
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const forgotpass = () => {
    navigate("/forgotpassword");
  }

  const handleKeyPress = (event) => {
    // Check if the pressed key is Enter (key code 13)
    if (event.key === 'Enter') {
      event.preventDefault();  // Prevent the default form submission
      handleSubmit(event);
    }
  };


  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className='login-page'>
        <div>
          <Link to="/">
            <img src="/assets/image/loginimage.png" alt='logo' className='login-page-img' />
          </Link>
        </div>
        <div className='login-page-right'>
          <div className='login-page-first-heading'>Hello!</div>
          <div className='login-page-second-heading'>Welcome Back👋</div>
          <div className='login-page-third-heading'>The world is just a step away from here </div>
          <form onSubmit={handleSubmit} onKeyDown={handleKeyPress} className="register-form">
            <div className="flex-column">
              <label htmlFor="email" className='form-labels'>Email</label>
              <input
                type="text"
                id="email"
                name="email"
                placeholder="example@gmail.com"
                autoComplete="off"
                onChange={handleInputChange}
                value={formData.email}
                className={`form-input ${errors.email ? 'error' : inputState.email ? 'success' : ''}`}
              />
              {errors.email && (<span className="error-message">{errors.email}</span>)}</div>
            <div className="flex-column">
              <label htmlFor="password" className='form-labels'>Password:</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="*********"
                  id="password"
                  name="password"
                  onChange={handleInputChange
                  }
                  value={formData.password}
                  className={`form-input ${errors.password ? 'error' : inputState.password ? 'success' : ''}`}
                />
                {errors.password && (<span className="error-message">{errors.password}</span>)}
                <button
                  type="button"
                  style={{ position: 'absolute', right: 20, top: 20 }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <PasswordEye />
                  ) : (
                    <PasswordEyeHidden />
                  )}
                </button>
              </div>
            </div>
            <button className="forgotbutton" onClick={forgotpass}>Forgot Password ?</button>
            <div>
              <button type="submit" className="login-button" >Sign In</button></div>
            <p
              style={{ color: "red" }}
              className={errMsg ? "errmsg" : "offscreen"}
              aria-live="assertive"
            >{errMsg}</p>
          </form>
        </div>
      </div>
    </>
  )
}

export default Login